import { render, staticRenderFns } from "./ReceiptPaymentDetail.vue?vue&type=template&id=2b8ca994&scoped=true"
import script from "./ReceiptPaymentDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ca994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8ca994')) {
      api.createRecord('2b8ca994', component.options)
    } else {
      api.reload('2b8ca994', component.options)
    }
    module.hot.accept("./ReceiptPaymentDetail.vue?vue&type=template&id=2b8ca994&scoped=true", function () {
      api.rerender('2b8ca994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/receiptpayment/ReceiptPaymentDetail.vue"
export default component.exports